module.exports = __webpack_public_path__ + "static/media/twoPeopleImage.d6cceb6a.svg";